<template>
	<div>
		<header class="flex gap-2 content-between items-center">
			<h1 class="alpha heavy">Dashboard</h1>
			<!--			<ul class="flex gap-1">-->
			<!--				<li v-if="$can('quote.create')"><router-link-->
			<!--					:to="{name: 'quotes.create'}"-->
			<!--					class="button button&#45;&#45;primary&#45;&#45;small">New Quote</router-link></li>-->
			<!--				<li v-if="$can('product.buy')"><router-link-->
			<!--					:to="{name: 'products.index'}"-->
			<!--					class="button button&#45;&#45;primary&#45;&#45;small"><span>Buy Products</span></router-link></li>-->
			<!--				<li v-if="$can('introduction.create')"><router-link-->
			<!--					:to="{name: 'services.index'}"-->
			<!--					class="button button&#45;&#45;primary&#45;&#45;small"><span>Refer Services</span></router-link></li>-->
			<!--			</ul>-->
		</header>
		<div>
			<loader v-if="loading"/>
			<div v-else class="sections">
				<section class="section--full">
					<div class="sections">
						<section class="section section--floating section--full">
							<header class="mb-2">
								<h2 class="beta heavy">Client actions</h2>
							</header>
							<div class="sections">
								<dl class="sections section--flat section--full">
									<!--									<AppMetricDistribution-->
									<!--										:data="data.managedClients.unRegistered" title="Unregistered"/>-->
									<!--									<AppMetricDistribution-->
									<!--										:data="data.managedClients.unPaid" title="Unpaid"/>-->
									<AppMetricNumber
										:amount="data.managedClients.unRegistered.total" :link="{
											name: 'clients.index',
											hash: '#unregistered',
										}"
										class="section section--flexed" tag="div" title="Unregistered"/>
									<AppMetricNumber
										:amount="data.managedClients.unPaid.total" :link="{
											name: 'clients.index',
											hash: '#unpaid',
										}"
										class="section section--flexed" tag="div" title="Unpaid"/>
									<AppMetricNumber
										:amount="data.managedClients.pendingId.total" :link="{
											name: 'clients.index',
											hash: '#pending-id',
										}"
										class="section section--flexed" tag="div"
										title="Pending ID"/>
								</dl>
								<!--								<dl class="section section&#45;&#45;flat section&#45;&#45;full">-->
								<!--									<AppMetricDistribution-->
								<!--										:data="data.managedClients.idChecks.statuses.pending" title="Pending"/>-->
								<!--									<AppMetricDistribution-->
								<!--										:data="data.managedClients.idChecks.statuses.ordered" title="Ordered"/>-->
								<!--									<AppMetricDistribution-->
								<!--										:data="data.managedClients.idChecks.statuses.started" title="Started"/>-->
								<!--									<AppMetricDistribution-->
								<!--										:data="data.managedClients.idChecks.statuses.inProgress"-->
								<!--										title="In progress"/>-->
								<!--									&lt;!&ndash;								<dt>Complete</dt>&ndash;&gt;-->
								<!--									&lt;!&ndash;								<dd>&ndash;&gt;-->
								<!--									&lt;!&ndash;									<AppMetricPercent&ndash;&gt;-->
								<!--									&lt;!&ndash;										:amount="data.managedClients.idChecks.statuses.complete.count"&ndash;&gt;-->
								<!--									&lt;!&ndash;										:percent="data.managedClients.idChecks.statuses.complete.distribution.percent"&ndash;&gt;-->
								<!--									&lt;!&ndash;										tag="div"/>&ndash;&gt;-->
								<!--									&lt;!&ndash;								</dd>&ndash;&gt;-->
								<!--									&lt;!&ndash;								<dd>&ndash;&gt;-->
								<!--									&lt;!&ndash;									<AppDistributionBar&ndash;&gt;-->
								<!--									&lt;!&ndash;										:data="data.managedClients.idChecks.statuses.complete.distribution"&ndash;&gt;-->
								<!--									&lt;!&ndash;										class="app-distribution-bar&#45;&#45;green"/>&ndash;&gt;-->
								<!--									&lt;!&ndash;								</dd>&ndash;&gt;-->
								<!--								</dl>-->
							</div>
						</section>
						<section class="section--full section--floating section--expanded">
							<div class="sections">
								<!--								<div class="section section&#45;&#45;full">-->
								<!--									<header class="flex content-between gap-2 mb-2">-->
								<!--										<h2 class="beta heavy">Leads</h2>-->
								<!--										&lt;!&ndash;										<dl>&ndash;&gt;-->
								<!--										&lt;!&ndash;											<dt class="sr-only">Leads status</dt>&ndash;&gt;-->
								<!--										&lt;!&ndash;											<dd class="icon icon&#45;&#45;alert&#45;&#45;error">error</dd>&ndash;&gt;-->
								<!--										&lt;!&ndash;										</dl>&ndash;&gt;-->
								<!--									</header>-->
								<!--									<dl class="sections">-->
								<!--										<div class="section section&#45;&#45;flat section&#45;&#45;flexed flex content-around gap-4">-->
								<!--											<AppMetricNumber :amount="data.leads.total" tag="div" title="Total"/>-->
								<!--										</div>-->
								<!--										<div class="section section&#45;&#45;flat section&#45;&#45;flexed flex content-around gap-4">-->
								<!--											<AppMetricPercent-->
								<!--												:amount="data.leads.new.count"-->
								<!--												:percent="data.leads.new.percent" tag="div"-->
								<!--												title="New"/>-->
								<!--											<AppMetricPercent-->
								<!--												:amount="data.leads.potential.count"-->
								<!--												:percent="data.leads.potential.percent" tag="div"-->
								<!--												title="Potential"/>-->
								<!--											<AppMetricPercent-->
								<!--												:amount="data.leads.inactive.count"-->
								<!--												:percent="data.leads.inactive.percent" tag="div"-->
								<!--												title="Inactive"/>-->
								<!--											<AppMetricPercent-->
								<!--												:amount="data.leads.instructed.count"-->
								<!--												:percent="data.leads.instructed.percent" tag="div"-->
								<!--												title="Instructed"/>-->
								<!--										</div>-->
								<!--									</dl>-->
								<!--								</div>-->
								<div class="section section--full">
									<header class="flex content-between gap-2 mb-2">
										<h2 class="beta heavy">Leads</h2>
									</header>
									<dl class="sections section--flat section--full">
										<AppMetricNumber
											:amount="data.leads.new.total"
											class="section section--flexed" tag="div" title="New"/>
										<AppMetricNumber
											:amount="data.leads.potential.total"
											class="section section--flexed" tag="div"
											title="Potential"/>
										<AppMetricNumber
											:amount="data.leads.inactive.total"
											class="section section--flexed" tag="div"
											title="Inactive"/>
										<!--										<AppMetricDistribution :data="data.leads.new" title="New"/>-->
										<!--										<AppMetricDistribution :data="data.leads.potential" title="Potential"/>-->
										<!--										<AppMetricDistribution :data="data.leads.inactive" title="Inactive"/>-->
									</dl>
								</div>
								<div class="section section--full section--bordered">
									<header class="flex content-between gap-2 mb-2">
										<h2 class="beta heavy">Cases</h2>
									</header>
									<dl class="sections section--flat section--full">
										<!--										<AppMetricDistribution :data="data.instructions.new" title="New"/>-->
										<!--										<AppMetricDistribution :data="data.instructions.inactive" title="Inactive"/>-->
										<AppMetricNumber
											:amount="data.instructions.new.total" class="section section--flexed"
											tag="div" title="New"/>
										<AppMetricNumber
											:amount="data.instructions.inactive.total"
											class="section section--flexed" tag="div" title="Inactive"/>
									</dl>
									<!--									<dl class="sections">-->
									<!--										<div class="section section&#45;&#45;flat section&#45;&#45;flexed flex content-around gap-4">-->
									<!--											<AppMetricNumber-->
									<!--												:amount="data.instructions.total"-->
									<!--												tag="div"-->
									<!--												title="Total"/>-->
									<!--										</div>-->
									<!--										<div class="section section&#45;&#45;flat section&#45;&#45;flexed flex content-around gap-4">-->
									<!--											<AppMetricPercent-->
									<!--												:amount="data.instructions.new.count"-->
									<!--												:percent="data.instructions.new.percent" tag="div"-->
									<!--												title="New"/>-->
									<!--											<AppMetricPercent-->
									<!--												:amount="data.instructions.inactive.count"-->
									<!--												:percent="data.instructions.inactive.percent" tag="div"-->
									<!--												title="Inactive"/>-->
									<!--											<AppMetricPercent-->
									<!--												:amount="data.instructions.complete.count"-->
									<!--												:percent="data.instructions.complete.percent" tag="div"-->
									<!--												title="Complete"/>-->
									<!--										</div>-->
									<!--									</dl>-->
								</div>
								<!--								<div class="section section&#45;&#45;full section&#45;&#45;bordered">-->
								<!--									<header>-->
								<!--										<h2 class="beta heavy">Referrals</h2>-->
								<!--									</header>-->
								<!--								</div>-->
							</div>
						</section>
					</div>
				</section>
				<!--				<section class="section&#45;&#45;full">-->
				<!--					<header class="mb-2 flex gap-2 content-between items-center">-->
				<!--						<h2 class="beta heavy">Analytics</h2>-->
				<!--					</header>-->
				<!--					<div class="sections">-->
				<!--						<section class="section section&#45;&#45;floating section&#45;&#45;full">-->
				<!--							<header class="mb-2 flex gap-2 content-between items-center">-->
				<!--								<h3 class="beta">Quotes</h3>-->
				<!--							</header>-->
				<!--							<dl class="section section&#45;&#45;flat section&#45;&#45;full flex content-around gap-4">-->
				<!--								<div>-->
				<!--									<dt class="all-caps gamma">Visits</dt>-->
				<!--									<div class="flex gap-1 items-center">-->
				<!--										<dd>-->
				<!--											<div class="flex flex-row-reverse gap-1 content-end items-center">-->
				<!--												<span class="alpha" v-html="data.quotesDisplayed"/>-->
				<!--											</div>-->
				<!--										</dd>-->
				<!--									</div>-->
				<!--								</div>-->
				<!--								<div>-->
				<!--									<dt class="all-caps gamma">Quotes</dt>-->
				<!--									<div class="flex gap-1 items-center">-->
				<!--										<dd>-->
				<!--											<div class="flex flex-row-reverse gap-1 content-end items-center">-->
				<!--												<span class="alpha" v-html="data.quotesCreated"/>-->
				<!--											</div>-->
				<!--										</dd>-->
				<!--									</div>-->
				<!--								</div>-->
				<!--								<div>-->
				<!--									<dt class="all-caps gamma">Leads</dt>-->
				<!--									<div class="flex gap-1 items-center">-->
				<!--										<dd>-->
				<!--											<div class="flex flex-row-reverse gap-1 content-end items-center">-->
				<!--												<span class="alpha" v-html="data.quotesConverted"/>-->
				<!--											</div>-->
				<!--										</dd>-->
				<!--									</div>-->
				<!--								</div>-->
				<!--								<div>-->
				<!--									<dt class="all-caps gamma">Instructions</dt>-->
				<!--									<div class="flex gap-1 items-center">-->
				<!--										<dd>-->
				<!--											<div class="flex flex-row-reverse gap-1 content-end items-center">-->
				<!--												<span class="alpha" v-html="data.quotesInstructed"/>-->
				<!--											</div>-->
				<!--										</dd>-->
				<!--									</div>-->
				<!--								</div>-->
				<!--							</dl>-->
				<!--						</section>-->
				<!--					</div>-->
				<!--				</section>-->
			</div>
		</div>
	</div>
</template>
<script>
import AppMetricDistribution from "@/components/AppMetricDistribution.vue";
import {mapActions, mapState} from "vuex";

export default {
	components: {
		AppMetricDistribution,
	},

	computed: {
		...mapState("dashboard", [
			"loading",
			"data",
		]),
	},

	methods: {
		...mapActions("dashboard", [
			"getData",
		]),
		alertClass(level) {
			let classes = {
				"icon": true,
			};
			classes["icon--alert--" + level] = true;
			return classes;
		},
		alertIsUnhealthy(levelData) {
			return levelData.health > 0;
		},
	},

	created() {
		this.getData();
	},
};
</script>
